import { ref } from 'vue'

export type AppConfirmOptions = {
  header: string
  message: string
  acceptLabel?: string
  rejectLabel?: string
  acceptSeverity?: 'primary' | 'secondary' | 'warn' | 'danger'
  hideReject?: boolean
  accept?: () => void
  reject?: () => void
}

// Module-level singleton consumed by ConfirmDialogHost, mirroring appToast
export const confirmState = ref<AppConfirmOptions | null>(null)

export const appConfirm = (options: AppConfirmOptions) => {
  confirmState.value = options
}
